import { render, staticRenderFns } from "./inputMap.vue?vue&type=template&id=cb4e58f8"
import script from "./inputMap.vue?vue&type=script&lang=js"
export * from "./inputMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports